import script from "./PageWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./PageWrapper.vue?vue&type=style&index=0&id=1818b593&lang=scss&scoped=true"
import "./PageWrapper.vue?vue&type=style&index=1&id=1818b593&lang=scss"

import exportComponent from "/codebuild/output/src2512880693/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1818b593"]])

export default __exports__